import { io } from "socket.io-client";
import { serverUrl } from "../../../config/apiConfig";

export const notificationSocket = io(
  `${serverUrl}/notifications`,
  {
    autoConnect: false,
    transports: ["websocket"],
    withCredentials: true,
  }
);
